<template>
  <div class="sp-page">
    <div class="page-header">
      <img class="header-img" src="@/assets/images/login/header-img.png" />
      <div class="header-title">Login and Publish</div>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="Publish News" name="News">
        <PublishNews ref="tpNews" @handleSubmitList="handleSubmitList"></PublishNews>
      </el-tab-pane>
      <el-tab-pane label="Publish Events" name="Events">
        <PublishEvents ref="tpEvents" @handleSubmitList="handleSubmitList"></PublishEvents>
      </el-tab-pane>
      <el-tab-pane label="Published Lists" name="Lists">
        <PublishLists ref="tpLists" @update-parent-data="handleEdit"></PublishLists>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import PublishNews from "./components/PublishNews.vue";
import PublishEvents from "./components/PublishEvents.vue";
import PublishLists from "./components/PublishLists.vue";
export default {
  components: {
    PublishNews,
    PublishEvents,
    PublishLists,
  },
  data() {
    return {
      activeName: "News",
    };
  },
  methods: {
    handleSubmitList() {
      //重新加载列表数据后跳转
      this.$refs.tpLists.getList();
      this.activeName = "Lists";
    },
    handleEdit(aid,type){
      if(type === 1){
         this.activeName = "News";
         this.$refs.tpNews.editAticle(aid);
      } else{
        this.activeName = "Events";
        this.$refs.tpEvents.editAticle(aid);
      }
    },
    handleClick() {
      if (this.activeName != "Events"){
        //处理富文本控件不刷新问题
         this.$refs.tpEvents.open = false;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.sp-page {
  width: 100%;
  .page-header {
    position: relative;
    img {
      width: 100%;
      display: block;
    }
    .header-title {
      position: absolute;
      left: fw(205vw, pc);
      bottom: fh(36vh, pc);
      font-size: fh(48vh, pc);
      color: #ffffff;
      line-height: fh(58vh, pc);
    }
  }
  ::v-deep .el-tabs {
    width: 100%;
    .el-tabs__content {
      padding: fh(60vh, pc) fw(200vw, pc);
    }
    .el-tabs__header {
      width: 100%;
      left: 0;
      background: #ececec;
      padding: 0 fw(200vw, pc);
      margin-bottom: 0;
    }
    .el-tabs__nav-scroll {
      padding: fh(30vh, pc) 0 !important;
    }
    .el-tabs__item {
      font-size: fh(16vh, pc);
      color: #999999;
      &.is-active {
        color: #333333;
        font-size: fh(18vh, pc);
      }
    }
    .el-tabs__active-bar {
      bottom: fh(-30vh, pc);
      background: #0077d4;
    }
  }
}
</style>
